// extracted by mini-css-extract-plugin
module.exports = {"L_12":"L_L_12__TC_xr"};